module.exports = __webpack_public_path__ + "img/person-dress.ff13e7b0.svg";